<div class="example-loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [style.zoom]="0.5" *ngIf="isLoadingResults"></mat-spinner>
</div>
<div class="popup_main_div add_edit_matter_main" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="dialog-title">
    <span>
      {{ _data.Type === 'edit' ? 'Edit Application' : 'New Application' }}
    </span>

    <button mat-icon-button class="close-btn" [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div class="apiaccess mat-dialog-content" [formGroup]="ApiAccessPopup">
    <!-- Application Name -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Application Name</mat-label>
      <input matInput formControlName="APPLICATIONNAME" />
    </mat-form-field>

    <p class="helper-text mt-3">
      The name of your OAuth 2.0 client. This name is only used to identify the client and will not
      be shown to end users.
    </p>

    <!-- Description -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Application Description</mat-label>

      <textarea
        matInput
        rows="3"
        formControlName="APPLICATIONDESCRIPTION"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
    </mat-form-field>

    <div class="info-box">
      <mat-icon>info</mat-icon>

      <span>The domains of the redirect URLs below will be used for your OAuth application.</span>
    </div>

    <mat-card class="redirect-card">
      <h3>Authorized Redirect URLs</h3>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Redirect URL 1</mat-label>
        <input matInput formControlName="REDIRECTURL" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width mt-4">
        <mat-label>Redirect URL 2</mat-label>
        <input matInput formControlName="REDIRECTURL2" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width mt-4">
        <mat-label>Redirect URL 3</mat-label>
        <input matInput formControlName="REDIRECTURL3" />
      </mat-form-field>
    </mat-card>

    <div class="toggle-section">
      <mat-slide-toggle formControlName="ALLOWPUBLICCLIENT">Allow Public Client</mat-slide-toggle>

      <mat-slide-toggle *ngIf="_data.Type === 'edit'" formControlName="ISACTIVE">
        Is Active
      </mat-slide-toggle>

      <mat-slide-toggle *ngIf="_data.Type === 'edit'" formControlName="REGENERATECLIENTSECRET">
        Regenerate Client Secret
      </mat-slide-toggle>
    </div>
  </div>

  <mat-dialog-actions align="end" class="popup_ftr justify-end">
    <button matButton="filled" color="accent" (click)="registerApplication()">
      {{ _data.Type === 'edit' ? 'Update' : 'Save' }}
    </button>
    <button matButton="tonal" color="primary" [mat-dialog-close]="false" cdkFocusInitial>
      Don`t Save
    </button>
  </mat-dialog-actions>
</div>
